import React from 'react';
import { Typography, Box, Container } from '@mui/material';
import AIAssistant from '../../components/AIAssistant';
import styles from './AskAIAssistant.module.css';

const AskAIAssistant: React.FC = () => {
    return (
        <Container maxWidth={false} className={styles.container} disableGutters>
            <Box className={styles.header}>
                <Typography variant="h4" className={styles.title}>
                    Ask AI Assistant
                </Typography>
                <Typography variant="body1" color="textSecondary" className={styles.subtitle}>
                    Get instant insights and analysis about your business data
                </Typography>
            </Box>
            
            <Box className={styles.content}>
                <Box className={styles.assistantWrapper}>
                    <AIAssistant />
                </Box>
                
                <Box className={styles.helpSection}>
                    <Typography variant="h6" gutterBottom>
                        What can I ask?
                    </Typography>
                    <Box className={styles.helpItems}>
                        <Typography variant="body2" component="div">
                            Inventory Status - Get current stock levels and alerts
                        </Typography>
                        <Typography variant="body2" component="div">
                            Sales Performance - View revenue metrics and trends
                        </Typography>
                        <Typography variant="body2" component="div">
                            Business Trends - Analyze market patterns and growth
                        </Typography>
                        <Typography variant="body2" component="div">
                            Sales Forecast - Get predictions based on historical data
                        </Typography>
                        <Typography variant="body2" component="div">
                            Product Analysis - Understand product performance
                        </Typography>
                        <Typography variant="body2" component="div">
                            Supplier Insights - Review supplier relationships
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Container>
    );
};

export default AskAIAssistant; 